/**
 * @Description: Header中导航组件
 * @Autho: 人杰
 * @Date:2019/10/18 11:23
 */

import React, {Component} from 'react';
// 路由对象
import {withRouter} from 'react-router-dom';
// Cookie对象
import Cookie from 'js-cookie';
// 引入antd的组件
import {Dropdown, Form, Icon, Menu, message,Select} from 'antd';

import styles from './HeadreNavView.less';
import {observe} from "mobx";
import {inject, observer} from "mobx-react";
import {map, every} from 'lodash';
import classNames from 'classnames';
const { Option } = Select;
@withRouter
@inject('AppStore')
@inject('HeaderNavMod')
@inject('HeaderGlobalMod')
@observer
 class HeaderNavView extends Component{
  constructor(props, context){
    super(props, context);
    this.store = this.props.HeaderNavMod;
    this.appStore = this.props.AppStore;
    this.state = {
      isOnlyOne: false
    };
  }
  componentWillUpdate(){
  }
  componentDidUpdate(){
  }
  componentWillMount(){
    const {style, className, HeaderNavMod: store } = this.props;
    // 获取应用
    this.store.getAppList({tenantId:Cookie.get("tenant_id"),filter:{},userId:Cookie.get('user_id')}).then(res =>{
      let arr = [];
      map(res.data, (item,index) => {
        if(item.isRelated == 1 && item.id !==1) {
          arr.push(item)
        }
      })
      if(arr.length == '1'){
        this.setState({isOnlyOne: true})
      }
      const headerNavBoc = localStorage.getItem('headerNavBoc') ? JSON.parse(localStorage.getItem('headerNavBoc')) : '';
      if(every(arr, item => item.code != 'BOC') && headerNavBoc){
        arr.unshift(headerNavBoc);
      }
      this.store.setAppList(arr);
      if(this.props.history.location.pathname == '/productDetail'||this.props.history.location.pathname == '/ProductDetail'){
        this.store.setAppInsName(Cookie.get('childrenAppInsName'))
      }
    })
  }
  componentDidMount() {

  }
  handleChange1(value){

  }
  render(){
    const {style={}, className, HeaderNavMod: store, prefix="HeaderNav",AppStore:AppStore,history: history} = this.props;
    const wrapCls = classNames( prefix , className);
    if(localStorage.getItem("roleCode") == 'BOCMANAGER'||store.appList.length==0||this.state.isOnlyOne){
      return null
    }
    return(
      <div className={wrapCls+ " f-row f-none"} style={{...style,display:'flex',alignItems:'center',marginLeft:'20px'}}>
        <Select className={styles.select}
          value={store.appInsName} onChange={(e)=>{
          this.handleChange1(e);
        }}>
          {
            store.appList&&store.appList.map((item,index)=>{
                return <Option className={styles.selectItem} key={index} onClick={(e) => store.appChange({item:item,AppStore:AppStore,history: history})} value={item.appInsName}>{item.appInsName}</Option>
            })
          }
        </Select>
      </div>
    )
  }
}

export default HeaderNavView


// WEBPACK FOOTER //
// ./src/widget/HeaderNav/HeaderNavView.js